var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.title,
            "close-on-click-modal": false,
            width: "950px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "140px",
                    "label-position": "right",
                  },
                },
                [
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("enable")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "账号状态：", prop: "enable" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.enable,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "enable", $$v)
                                },
                                expression: "form.enable",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("开启"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("关闭"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("channelCode")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "选择渠道：", prop: "channelCode" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.form.channelCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "channelCode", $$v)
                                },
                                expression: "form.channelCode",
                              },
                            },
                            _vm._l(
                              _vm.optionsData[_vm.PlatformName],
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("signSecret")
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "授权密钥", prop: "ext.signSecret" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.ext.signSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.ext, "signSecret", $$v)
                              },
                              expression: "form.ext.signSecret",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("apiId")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "联盟ID：", prop: "apiId" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.apiId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiId", $$v)
                              },
                              expression: "form.apiId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("mediaId")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "媒体位ID：", prop: "mediaId" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.ext.mediaId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.ext, "mediaId", _vm._n($$v))
                              },
                              expression: "form.ext.mediaId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("feePercent")
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "服务费预留比例：",
                            prop: "ext.feePercent",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-with-unit" },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  type: "number",
                                },
                                model: {
                                  value: _vm.form.ext.feePercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.ext,
                                      "feePercent",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "form.ext.feePercent",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("apiPromotionId")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "推广PID：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.apiPromotionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiPromotionId", $$v)
                              },
                              expression: "form.apiPromotionId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("apiAppKey")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "AppKey:" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.apiAppKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiAppKey", $$v)
                              },
                              expression: "form.apiAppKey",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("apiAppSecret")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "AppSecret：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.apiAppSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiAppSecret", $$v)
                              },
                              expression: "form.apiAppSecret",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("sid")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Sid：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.ext.sid,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.ext, "sid", $$v)
                              },
                              expression: "form.ext.sid",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("apiUrl")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "接口地址：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.apiUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiUrl", $$v)
                              },
                              expression: "form.apiUrl",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("tname")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "淘宝名称：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.ext.tname,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.ext, "tname", $$v)
                              },
                              expression: "form.ext.tname",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes(
                    "channelInviterCode"
                  )
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "邀请码：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.ext.channelInviterCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.ext,
                                  "channelInviterCode",
                                  $$v
                                )
                              },
                              expression: "form.ext.channelInviterCode",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("callBack")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "授权回调地址：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.ext.callBack,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.ext, "callBack", $$v)
                              },
                              expression: "form.ext.callBack",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("syncFlag")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "订单同步：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.syncFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "syncFlag", $$v)
                                },
                                expression: "form.syncFlag",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("同步"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不同步"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("syncStartTime")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "同步开始时间：" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetime",
                              placeholder: "选择日期时间",
                            },
                            model: {
                              value: _vm.form.syncStartTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "syncStartTime", $$v)
                              },
                              expression: "form.syncStartTime",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { color: "#FFB443" } }, [
                            _vm._v(
                              "\n            注：付款时间在设定时间中的订单不会同步到后台\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showItemData[_vm.PlatformName] &&
                  _vm.showItemData[_vm.PlatformName].includes("remark")
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "备注：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("formRef")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("formRef")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }